const axios = require("axios");

module.exports = axios.create({
  baseURL: "https://ww8.ikea.com",
  timeout: 5000,
  withCredentials: false
});



// WEBPACK FOOTER //
// ./src/libs/ww8.js